import React from 'react'
import UserHeader from '../Parts/Header/Header-Guest';
import {Event, decode, encode, wait, isMobile, SITE, sendNotfication} from "../../../Helper";

import storage from "../../../Storage";
import HeaderGuest from "../Parts/Header/Header-Guest";


class Faqs extends React.Component {
    _Mounted = false;
    constructor(props){
        super(props);
        this.state = {
            mobile:false,
            isLogged: false,
            token: false,
            userid: storage.getKey("uid"),
            header: <HeaderGuest t={this.props.t} location={this.props.location} />,
            auth: false
        }
        this.handleResize = this.handleResize.bind(this);
    }
    componentWillMount() {
        wait(500).then(() => {
            this._Mounted = true;
        })
    }

    componentDidMount() {
        wait(1700).then(() => {
            this.setState({ loading: false });
        })

    }


    getWidth(){
        return document.documentElement.clientWidth || document.body.clientWidth;
    }
    handleResize(){
        if(this.getWidth() < 1540)
        {
            this.setState({ col: 'col-xl-12'});
            Event.emit('hide_games');
        }
        else {
            this.setState({ col: 'col-xl-9'});
            Event.emit('show_min_games');
        }

        if(isMobile()){

            this.setState({ mobile: true });
        }
        else {
            this.setState({ mobile: false });
        }

        if(isMobile()){
            this.setState({ padding: 'p-0', ovh: 'ovh' });
        }
    }
    render(){
        let { header } = this.state;




        return(
            <>
                <div className="page-wrapper">

                    <div className="page-content container py-1 px-1" id={'page-content'}>
                        {header}
                        <section className="container">
                            <div className={"row justify-content-center"}>
                                
                            </div>


                        </section>
                    </div>
                </div>
            </>
        );
    }
}


export default Faqs;


